import { ContractListApp } from "document/list/app";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const contractRoute: RouteObject = {
  path: "contract",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ContractListApp,
  }]
};